import React from 'react';
import { ApaVisualsSoccerComponent } from '@src/interfaces';
import Soccer from '@src/components/ApaVisuals/Soccer';
import ParagraphProps from '@src/components/Paragraph/paragraph-props';

const ApaSoccerParagraph = (props: ParagraphProps) => (
  <Soccer {...(props.paragraph.data as ApaVisualsSoccerComponent)} />
);

export default ApaSoccerParagraph;
